import * as GrooveLocalStorage from 'GrooveLocalStorage';

function assembleSetCurrentUserPayload({ currentUserResponse }) {
  const loginAsActive = GrooveLocalStorage.fetch('loginAsActive') || false;
  const loginAsTime = GrooveLocalStorage.fetch('loginAsTime') || null;
  return { ...currentUserResponse.data, loginAsActive, loginAsTime };
}

export default assembleSetCurrentUserPayload;
